import nopInstance from "../nopInstance.js";

const getAllFilters = async () => {
    const response = await nopInstance.get("api/filter");
    return response;
}

const getFiltersByCategoryId = async (categoryId) => {
  const response = await nopInstance.get(`api/filter/${categoryId}`);
  return response;
};

const getSampleFilterData = async (categoryId, labelAttribute, valueAttribute, orderAttribute, orderAscDesc, filterBy = null, filterByValue = null) => {
  // only send filterBy and filterByValue if they both have data
  const filterByData = filterBy && filterByValue ? `/${filterBy}/${filterByValue}` : ''
  const response = await nopInstance.get(`api/filter/sample/${categoryId}/${labelAttribute}/${valueAttribute}/${orderAttribute}/${orderAscDesc}${filterByData}`);
  return response;
};

export default {
  getAllFilters,
  getFiltersByCategoryId,
  getSampleFilterData,
};